define("shared/utils/object-promise-proxy", ["exports", "@ember/object/proxy", "rsvp", "@ember/object/promise-proxy-mixin"], function (_exports, _proxy, _rsvp, _promiseProxyMixin) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.arrayPromiseProxy = arrayPromiseProxy;
  _exports.objectPromiseProxy = _exports.default = objectPromiseProxy;
  0; //eaimeta@70e063a35619d71f0,"@ember/object/proxy",0,"rsvp",0,"@ember/object/promise-proxy-mixin"eaimeta@70e063a35619d71f

  const ObjectPromiseProxy = _proxy.default.extend(_promiseProxyMixin.default);

  function objectPromiseProxy(model) {
    if (model instanceof _proxy.default) {
      const proxy = ObjectPromiseProxy.create({
        promise: _rsvp.default.resolve(model)
      });
      return proxy;
    }

    return _rsvp.default.resolve(model);
  }

  async function arrayPromiseProxy(arrayOfModels) {
    const output = [];

    for (const model of arrayOfModels) {
      output.push(await objectPromiseProxy(model));
    }

    return output;
  }
});